import React, {useEffect} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {setAssignQuotePopupEmployee} from "../../../actions/assignPopupFunctions";
import AssignQuoteVirtualizedList from "./assignQuoteVirtualizedList";
import {employeeInterface} from "./assignQuoteInterfaces";

const AssignQuoteEmployeesList = (props) => {

  const {employeesList, setAssignQuotePopupEmployee, assignQuotePopupEmployee, userInfo, contentDimensions,
    hideEmployeesList} = props;

  useEffect(() => {
    if (userInfo && userInfo.employeeId && !assignQuotePopupEmployee) {
      const employeeSelected = employeesList.find(employee => employee.id === userInfo.employeeId);
      if (employeeSelected) {
        setAssignQuotePopupEmployee(employeeSelected);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.employeeId]);

  if (hideEmployeesList) {
    return null
  }

  return (
    <AssignQuoteVirtualizedList
      contentDimensions={contentDimensions}
      renderList={employeesList}
      activeEntity={assignQuotePopupEmployee}
      selectEntity={setAssignQuotePopupEmployee}
      noEntitiesFound="assignPopup.noEmployeesFound"
      title="assignPopup.employeesTitle"
    />
  )
};

AssignQuoteEmployeesList.propTypes = {
  employeesList: PropTypes.arrayOf(PropTypes.shape(employeeInterface)).isRequired,
  assignQuotePopupEmployee: PropTypes.shape(employeeInterface),
  contentDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

const mapStateToProps = (store) => {
  return {
    assignQuotePopupEmployee: store.assignQuoteState.assignQuotePopupEmployee,
    userInfo: store.userState.userInfo,
  };
};

const mapDispatchToProps = {
  setAssignQuotePopupEmployee
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignQuoteEmployeesList)
